<div class="container-xxl">
  <div class="player-error-container">
    <div class="content-wrapper">
      <div class="title-wrapper">
        <i class="mb-icon mb-icon-attention-circle"></i>
        <h4>{{ 'AN_ERROR_OCCURED' | translate }}</h4>
      </div>
      <p class="copy-m error-text">{{ errorText || 'STREAM_PLAYER_ERROR_TEXT' | translate }}</p>
      <div class="button-container">
        <button class="btn btn-primary" (click)="reloadPlayer()">{{ 'REFRESH_PLAYER' | translate }}</button>
        <button class="btn btn-secondary" (click)="closePlayer()">{{ 'CLOSE_PLAYER' | translate }}</button>
      </div>
    </div>
  </div>
</div>
